import { FC } from 'react'
import { IconProps } from '../../../LandingPage.icons'

const Rainbow: FC<IconProps> = ({
  className = '',
  svgClassName = '',
  height = 70,
  width = 114,
}) => (
  <span aria-label="Rainbow Icon" className={className} role="img">
    <svg
      className={svgClassName}
      fill="currentColor"
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M74.1397 0C35.0677 0 2.98148 28.2336 0.0165583 63.9231C-0.227134 66.7994 2.25041 69.2594 5.3778 69.2594H37.0578C39.3323 69.2594 41.2412 67.7077 41.5255 65.6262C43.4751 50.4496 57.3656 38.6415 74.1397 38.6415C89.9797 38.6415 103.261 49.1629 106.348 63.0904C107.119 66.648 110.45 69.2594 114.349 69.2594H143.633C146.354 69.2594 148.507 67.1022 148.303 64.5665C145.704 28.5742 113.415 0 74.1397 0Z" />
    </svg>
  </span>
)

export default Rainbow
